import { Intervention } from '@/app/components/action-plan/types';
import { Box, IconArrowRight, Link, UnorderedList } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useActionPlanSummaryController } from './action-plan-summary.controller';
import ActionPlanSummaryIntervention from './components/action-plan-summary-intervention';
import { ROUTE_ACTION_PLAN } from '@/constants/routes';
import { TypeOfCancer } from '../icons/icon-catch/types';
type ActionPlanSummaryProps = {
  recommendedInterventions: Intervention[];
  handleOpenDetailsModal: (intervention: Intervention) => void;
  cancerId: TypeOfCancer;
};

export default function ActionPlanSummary({
  recommendedInterventions,
  handleOpenDetailsModal,
  cancerId,
}: ActionPlanSummaryProps) {
  const { getBadgeValue } = useActionPlanSummaryController();

  return (
    <Box background="#F0F5F6" borderRadius="radii-3">
      <UnorderedList py="6" px="2" pr="4">
        {recommendedInterventions?.map((intervention) => {
          if (!intervention) return null;

          return (
            <ActionPlanSummaryIntervention
              key={intervention.id}
              icon={intervention.category}
              text={intervention.title}
              badgeValue={getBadgeValue(intervention, cancerId)}
              onClick={() => handleOpenDetailsModal(intervention)}
            />
          );
        })}
      </UnorderedList>
      <Link
        as={ReactRouterLink}
        to={ROUTE_ACTION_PLAN}
        trailingIcon={<IconArrowRight size="xs" />}
        borderRadius="radii-3"
        p="3"
        background="#F0F5F6"
        width="100%"
        display="flex"
        justifyContent="center"
        borderTop="1px solid"
        borderColor="cream"
      >
        View Action Plan
      </Link>
    </Box>
  );
}
